<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text="">
      <div slot="content">
        <lk-card title="相关单据信息">
          <lk-row :gutter="16">
            <lk-col>
              <lk-table
                ref="table"
                border
                :columns="columns"
                :data="tableData">
              </lk-table>
              <div style="margin-top: 14px; text-align: right;">
                <lk-page
                  :total="count"
                  :page-size="size"
                  :current="page"
                  size="small"
                  show-sizer
                  show-total
                  show-elevator
                  @on-change="handlePage"
                  @on-page-size-change="handleSize">
                </lk-page>
              </div>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
    </baseFrame>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import toolsService from '../../services/tools';
import utils from '../../libs/utils';

export default {
  name: 'MergeEqualGoodsBizInfo',
  components: {
    baseFrame,
  },
  data() {
    return {
      page: 1,
      size: 20,
      count: 0,
      tableData: [],
      columns: [
        { title: '门店名称', key: 'storeName', minWidth: 116 },
        {
          title: '单据类型',
          key: 'tableName',
          minWidth: 130,
        },
        {
          title: '单号',
          key: 'code',
          minWidth: 116,
        },
      ],
    };
  },
  computed: {},
  methods: {
    getData() {
      const params = {
        size: this.size,
        page: this.page,
        operateDetailId: this.id,
      };
      toolsService.getMergeEqualGoodsRelBizList(params).then((res) => {
        if (res.data.status === 200) {
          const { list, count } = res.data.data;
          this.tableData = list;
          this.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handlePage(val) {
      this.page = val;
      this.getData();
    },
    handleSize(val) {
      this.size = val;
      this.getData();
    },
  },
  created() {
    this.id = this.$route.params.id;
    if (this.id) {
      this.getData();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
